import "%modules%/header/header";
import "%modules%/brand/brand";
import "%modules%/design/design";
import "%modules%/advantages/advantages";
import "%modules%/devices/devices";
import "%modules%/accordion/accordion";
import "%modules%/faq/faq";